import React from 'react';
import {FormInput} from "lucide-react";

function InputSingle({placeholder, target, data, required, className, handler, focus}) {
    const inputStyle = {
        backgroundColor: required && (!data.data || !data.data[target] || data.data[target].trim() === '' || data.data[target] === '') ? '#ffe5e5' : '#cee1f8',
        border: required && (!data.data || !data.data[target] || data.data[target].trim() === '' || data.data[target] === '') ? '2px solid #e53939' : '',
        outline: 'none'
    };

    const handleInputChange = (event) => {

        if (required && (!data.data || !data.data[target] || data.data[target].trim() === '' || data.data[target] === '')) {
        }

        data.setData((prev) => ({
            ...prev,
            [target]: event.target.value,
        }));
    };

    /**
     * 입력후 엔터 -> 성공시 입력칸 지워줌
     * */
    const handleOnKeyPress = (event) => {
        if (event.key === 'Enter') {
            const result = handler(event.target.value);
            if (result) {
                data.setData((prev) => ({
                    ...prev,
                    [target]: "",
                }));
            }
        }
    }

    return (
        <input
            placeholder={placeholder}
            type={"text"}
            className={`basic-input focus ${className}`}
            value={!data.data || !data.data[target] ? '' : data.data[target]}
            onChange={handleInputChange}
            onKeyDown={handleOnKeyPress}
            autoFocus={focus}
            style={required ? inputStyle : {}}
        />
    );
}

export default InputSingle;